import ToolProps from "../Util/ToolProps";

export default class Shape {
    constructor() {
        this.id = (new Date()).getTime();
        this.ctx = null;
        this.layer = '';
        this.props = new ToolProps();
    }
    draw() {}
    export() {}

    setContext(ctx) {
        this.ctx = ctx;
    }

    setLayer(layer) {
        this.layer = layer;
    }

    load (props) {
        for (let i in props) {
            if (props.hasOwnProperty(i)) {
                if (i === 'props') {
                    this.props.set(props[i]);
                } else {
                    this[i] = props[i];
                }
            }
        }
    }

    setProps(props) {
        this.props.set(props);
    }
    
    isHover() {return false;}
    isHoverPoint() {return false;}
    isUnderSelection(bounds) {return false;}
    relativeMove(point, origin) {return false;}
    getMoveableProps() {return [];}

    isText() {return false;}
    isShape() {return false;}
    isToken() {return false;}
    hasImage() {return false;}

    move() {}
    
    onMouseMove() {}
    terminateOnMouseUp() {return true;}
}